export default __webpack_public_path__ + "static/media/twenty-years-twenty-beers@2x.29cd1abc.jpg";